
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/privacy",
      function () {
        return require("private-next-pages/policy/privacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/privacy"])
      });
    }
  